export { VerticalSeparator } from './vertical-separator';
export type { VerticalSeparatorProps } from './vertical-separator';
